import type { SVGProps } from "react";
export default function SvgOpenPanel(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-panel-left-open-icon lucide-panel-left-open"
			viewBox="0 0 24 24"
			{...props}
		>
			<rect width={18} height={18} x={3} y={3} rx={2} />
			<path d="M9 3v18" />
			<path d="m14 9 3 3-3 3" />
		</svg>
	);
}
